import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=1d0c2afe"
import script from "./GroupCreate.vue?vue&type=script&lang=js"
export * from "./GroupCreate.vue?vue&type=script&lang=js"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=1d0c2afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports